module.exports = "img {\n  max-width: 60%;\n  max-height: 450px;\n}\n"